var __WEBPACK_NAMESPACE_OBJECT__ = window["wc"]["wcBlocksData"];